import { Dialog } from '@/components/Molecules/Dialog/Dialog';
import { PersonCard } from '@/components/Molecules/PersonCard/PersonCard';
import { Stack } from '@/components/Molecules/Stack/Stack';
import useTranslation from '@/hooks/useTranslation';
import { useTruncatedList } from '@/hooks/useTruncatedList';
import type { IPerson } from '@/interfaces';
import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './Contributors.module.css';

interface IProps {
    items: IPerson[];
}

const listRenderer = (listItems: IPerson[]) => (
    <Stack as="ul">
        {listItems.map((author) => (
            <li key={author.id}>
                <PersonCard person={author} />
            </li>
        ))}
    </Stack>
);

/**
 * Generates a list of secondary authors with links to author details page
 */
export const Contributors: FCl<IProps> = ({ items, className }) => {
    const { t } = useTranslation();
    const { dialog, truncated, itemsToRender, totalCount } = useTruncatedList(items);

    if (!items.length) {
        return null;
    }

    return (
        <div className={classNames(styles.panel, className)}>
            <h2 className="cds-t-h4">
                {t('common:Labels.contributors')} <span className={styles.count}>({totalCount})</span>
            </h2>
            {listRenderer(itemsToRender)}
            {truncated && (
                <Dialog title={t('common:Labels.contributors')} {...dialog}>
                    {listRenderer(items)}
                </Dialog>
            )}
            {truncated && (
                <button className="cds-button cds-button--tertiary" onClick={() => dialog.open()}>
                    {t('Actions.show_more')}
                </button>
            )}
        </div>
    );
};
